const getPriceSpecificationConfig = (pricing, vat)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const regularPrice = pricing === null || pricing === void 0 ? void 0 : pricing.value.centAmount;
    var _centAmount;
    const discountedPrice = (_centAmount = pricing === null || pricing === void 0 ? void 0 : (ref = pricing.discounted) === null || ref === void 0 ? void 0 : ref.value.centAmount) !== null && _centAmount !== void 0 ? _centAmount : 0;
    const currency = pricing === null || pricing === void 0 ? void 0 : pricing.value.currencyCode;
    const validFrom = pricing === null || pricing === void 0 ? void 0 : (ref1 = pricing.discounted) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.discount) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.obj) === null || ref3 === void 0 ? void 0 : ref3.validFrom;
    const validThrough = pricing === null || pricing === void 0 ? void 0 : (ref4 = pricing.discounted) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.discount) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.obj) === null || ref6 === void 0 ? void 0 : ref6.validUntil;
    const price = discountedPrice > 0 ? discountedPrice : regularPrice;
    const vatRate = vat ? vat : 0;
    return {
        price,
        vatRate,
        currency,
        validFrom,
        validThrough
    };
};

export { getPriceSpecificationConfig };
//# sourceMappingURL=get-price-specification-config.js.map
